import { writable, derived, type Writable } from 'svelte/store';
import type { Models } from '@smartlinkdev/types';
import { venue } from '$lib/stores';

const defaultLang: Models.Language = {
  id: 99999,
  created_at: new Date().toLocaleString(),
  updated_at: new Date().toLocaleString(),
  name: 'English',
  abbreviation: 'en',
};

export const exportLanguages = writable<Models.Language[]>([]);

export const languages = derived<Writable<Models.Language[]>, Models.Language[]>([exportLanguages], ([$exportLanguages]) => {
  return [defaultLang, ...$exportLanguages];
});

export const activeLanguage = writable<Models.Language>(defaultLang);

export const translations = writable<Models.Translation[]>([]);

export const activeTranslations = derived([activeLanguage, translations], ([$activeLanguage, $translations]) => {
  return $translations.filter((translation: Models.Translation) =>
    translation.language_id === $activeLanguage.id);
});

export const multiLingualEnabled = derived(
  [venue],
  ([$venue]) =>
    $venue?.settings?.translations?.enableMultiLingual || false,
);
